import React, { Component } from 'react';

import rluijten from '../../../img/rluijten.jpg';
import rluijten2x from '../../../img/rluijten-2x.jpg';
import rluijtenTablet from '../../../img/rluijten-tablet.jpg';
import rluijtenMobile from '../../../img/rluijten-mobile.jpg';

// eslint-disable-next-line
class ProfilePicture extends Component {
  componentDidMount() {
    this.rluijten = document.querySelector('#rluijten');

    this.mouseoverHandler = this.mouseoverHandler.bind(this);
    this.rluijten.addEventListener('mouseover', this.mouseoverHandler);

    this.mouseoutHandler = this.mouseoutHandler.bind(this);
    this.rluijten.addEventListener('mouseout', this.mouseoutHandler);
  }

  componentWillUnmount() {
    this.rluijten.removeEventListener('mouseover', this.mouseoverHandler);
    this.rluijten.removeEventListener('mouseout', this.mouseoutHandler);
  }

  mouseoverHandler() {
    this.toggleProfileImg();
  }

  mouseoutHandler() {
    this.toggleProfileImg();
  }

  toggleProfileImg() {
    if (window.innerWidth > 768) {
      if (this.node.classList.contains('about__image--show')) {
        this.node.classList.remove('about__image--show');
      } else {
        this.node.classList.add('about__image--show');
      }
    }
  }

  render() {
    return (
      <picture className="about__image about__image--portfolio" ref={(node) => { this.node = node; }}>
        <source srcSet={rluijtenMobile} media="(max-width: 480px)" />
        <source srcSet={rluijtenTablet} media="(max-width: 768px)" />
        <source srcSet={rluijten2x} media="(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)" />
        <source srcSet={rluijten} />
        <img src={rluijten} className="project__image" alt="Ruud Luijten" />
      </picture>
    );
  }
}

export default ProfilePicture;



// WEBPACK FOOTER //
// ./client/js/components/shared/ProfilePicture.js